import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* redeemPerk({ id, callbacks }) {
  try {
    const { data } = yield call(api.redeemPerk, id);
    yield put(Actions.redeemPerkSuccess(data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, data);
    }
  } catch (error) {
    yield put(Actions.redeemPerkFail(error));
    if (typeof callbacks?.fail === 'function') {
      yield call(callbacks.fail);
    }
  }
}

function* watchRedeemPerk() {
  yield takeLatest(Actions.REDEEM_PERK_REQUEST, redeemPerk);
}

export default function* redeem() {
  yield all([fork(watchRedeemPerk)]);
}
